import { useCallback, useEffect, useState } from 'react'

import { ApiErrorResponse, getKuchikomiApiClient } from '../../services/network'
import { Enterprise } from '../../clients/kuchikomi_api_client'
import { useAuthAuthorized } from '../auth/use_auth'

/**
 * 自社のクチコミ詳細情報を取得するフック
 */
export const useOwnDetail = (): {
  initialized: boolean
  enterprise: Enterprise | null
} => {
  const apiClient = getKuchikomiApiClient()
  const [kuchikomiEnterprise, setKuchikomiEnterprise] =
    useState<Enterprise | null>(null)
  const [initialized, setInitialized] = useState<boolean>(false)
  const { user } = useAuthAuthorized()

  const load = useCallback(async () => {
    // APIを叩く
    await apiClient.enterprises
      .enterprisesDetail(user.kuchikomiEnterpriseId)
      .then((response) => {
        setKuchikomiEnterprise(response.data)
      })
      .catch((e: ApiErrorResponse) => {
        console.error(e)
        return null
      })
      .finally(() => {
        setInitialized(true)
      })
  }, [])

  useEffect(() => {
    load()
  }, [])

  return { initialized, enterprise: kuchikomiEnterprise }
}
